<template>
<div class="summary-box mt-3">
  <div class="small text-uppercase text-muted mb-1">What happens</div>
  <ul class="mb-0"><slot></slot></ul>
</div>
</template>

<script>
// "What happens next" list.
export default {}
</script>
